/**
 * Returns a promise that resolves after a timeout
 * @param {number} ms Timeout in milliseconds
 * @returns {Promise} Resolves after timeout
 */
function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export const $async = { delay }
